// extracted by mini-css-extract-plugin
export default {"tooltip":"Co-z","sharingV2":"Do-z","sharingIconsV2":"Eo-z","links":"Fo-z","link":"Go-z","facebookV2":"Ho-z","twitterV2":"Io-z","pinterestV2":"Jo-z"};